import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseCategoryResponse, WarehouseRequest, WarehouseResponse } from 'src/app/models/warehouse.model';
import { WarehouseService } from 'src/app/services/warehouse.service';

@Component({
  selector: 'app-warehouses',
  templateUrl: './warehouses.component.html',
  styleUrls: ['./warehouses.component.scss']
})
export class WarehousesComponent implements OnInit {
  warehouses: WarehouseResponse[] = [];
  warehouseCategories: WarehouseCategoryResponse[] = [];
  editing = false;
  filterWarehouses: WarehouseResponse[] = [];
  filterWord: string = "";
  creating = false;
  edit = null;
  warehouseEdit = null;

  constructor(
    private warehouseService: WarehouseService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {
    this.getCategories();
  }

  closeCreate(created: boolean) {
    this.creating = false;
    if (created) {
      this.getCategories();
    }
  }

  closeEdit(edited: boolean) {
    this.editing = false;
    this.edit = null;
    this.warehouseEdit = null;
    if (edited) {
      this.getCategories();
    }
  }

  editWarehouse(warehouse: WarehouseResponse) {
    var newWarehouse = new WarehouseRequest();
    newWarehouse = Object.assign({}, {
      ...warehouse,
      gface: warehouse.gfaceEnabled
    });
    this.edit = newWarehouse;
    this.warehouseEdit = warehouse.id;
    this.editing = true;
  }

  getCategories() {
    this.warehouseService.getWarehouses().subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        this.filterWarehouses = this.warehouses;
        this.getCategoryWarehouses();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getCategoryName(id: number) {
    var temp = this.warehouseCategories.find((w) => w.id == id);
    return (temp) ? temp.category : '';
  }

  activeOrInactive(warehouse: any) {
    this.warehouseService.activeOrInactiveWarehouse(warehouse.id).subscribe({
      next: (response: any) => {
        warehouse.active = !warehouse.active;
        this.toastService.success("Se ha " + ((warehouse.active) ? 'activado' : 'desactivado') + " correctamente la bodega");
      },
      error: (error: any) => {
        this.toastService.success("Error al " + (warehouse.active) ? 'desactivar' : 'activar' + " la bodega");
      }
    })
  }

  getCategoryWarehouses() {
    this.warehouseService.getCategoryWarehouses().subscribe({
      next: (response: ResponseObject) => {
        this.warehouseCategories = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  filter() {
    this.filterWarehouses = this.warehouses.filter((w) => {
      return (w.code + " - " + w.name).toLowerCase().includes(this.filterWord.toLowerCase());
    })
  }

}
